import { render, staticRenderFns } from "./SupportTicket.vue?vue&type=template&id=0b8d4dd3&scoped=true&"
import script from "./SupportTicket.vue?vue&type=script&lang=js&"
export * from "./SupportTicket.vue?vue&type=script&lang=js&"
import style0 from "./SupportTicket.vue?vue&type=style&index=0&id=0b8d4dd3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b8d4dd3",
  null
  
)

export default component.exports